import React, { Fragment } from "react";
import PropTypes from "prop-types";

import Form from "../../common/Form";
import Fieldset from "../../common/Fieldset";
import Row from "../../common/Row";
import TextInput from "../../common/TextInput";
import Table from "../../common/Table";
import Button from "../../common/Button";
import SelectInput from "../../common/SelectInput";
import AutoComplete from "../../common/AutoComplete";
import CheckBoxWithChild from "../../common/CheckBoxWithChild";
import { RelatieTypes, UserTypes, RelatieTypesEnum } from "../../../constants/DomainConstants";

const LinkAddForm = (props) => {
	const {
		onCancel,
		onContinue,
		orgTypes,
		sporttakken,
		typeFilter,
		relatieType,
		naamFilter,
		sporttakFilter,
		onChangeFilter,
		onSearch,
		searchModels,
		onChangeToAdd,
		models,
		sportVlaanderenRoot,
		naamFilterHasFocus,
		userType
	} = props;

	const linkClass = { "color": "#39b4e8", "font-weight": "bold", "paddingBottom": '2px', "paddingTop": '2px' };
	const tdStyle = { paddingBottom: '2px', paddingTop: '2px', borderStyle: 'solid', borderWidth: "1px", borderColor: '#eeefef', height: '80' };

	const searchResultRows = searchModels.map((item, index) => {
		const existingLidmaatschap = models.find(e => e.id === item.id);
		const disabled = item.isLinked || !!existingLidmaatschap;
		const value = disabled || !!item.checked;
		const type = item.type === "Federatie" ? "Sportfederatie" : item.type;
		return (
			<tr key={index} style={{ borderStyle: 'solid', borderWidth: "1px", borderColor: '#eeefef', height: '80' }}>
				<td style={{ padding: '5px' }}>
					<CheckBoxWithChild
						key={index}
						name={item.id}
						disabled={disabled}
						value={value}
						onChange={onChangeToAdd} />
				</td>
				<td style={tdStyle}><a style={linkClass} href={sportVlaanderenRoot + "/sportorganisatie?OrgId=" + item.id} target={"_blank"}>{item.naam + (item.afkorting ? " (" + item.afkorting + ")" : "")}</a></td>
				<td>{type}</td>
				<td>{item.sporttakken && item.sporttakken.split(',').length > 1 ? "Multisport" : item.sporttakken}</td>
			</tr>
		);
	});

	const validRelatieTypeSelected = !relatieType || relatieType < 0;

	const filteredRelatieTypes = userType === UserTypes.WEBSITEBEZOEKER ? RelatieTypes.filter(el => el.value !== RelatieTypesEnum.GESUBSIDIEERD_DOOR) : RelatieTypes;

	return (
		<Form
			headerVisible={false}
			isNotRequired
			rightButtonLabel="Ga verder"
			onRightButtonClick={onContinue}
			leftButtonLabel="Annuleer"
			onLeftButtonClick={onCancel}>
			<Fieldset title="Link / relatie toevoegen">
				<Row><h1 style={{ color: "#777" }}>Bovenliggend</h1></Row>
				<Row><h3 style={{ color: "#39b4e8" }}>Relatiegegevens</h3></Row>
				<Row>
					<SelectInput
						name="relatieType"
						value={relatieType}
						label="Soort relatie"
						items={filteredRelatieTypes}
						onChange={onChangeFilter}
						size={6} />
				</Row>
				<Row><h3 style={{ color: "#39b4e8" }}>Zoek organisatie</h3></Row>
				<Row>
					<SelectInput
						name="typeFilter"
						value={typeFilter}
						label="Type"
						items={orgTypes}
						onChange={onChangeFilter}
						size={6}
						defaultItemVisible={false}
						disabled={validRelatieTypeSelected} />
					<AutoComplete
						name="sporttakFilter"
						value={sporttakFilter}
						label="Sporttak"
						items={sporttakken}
						onChange={onChangeFilter}
						size={6}
						clearable
						disabled={validRelatieTypeSelected} />
				</Row>
				<Row>
					<TextInput
						name="naamFilter"
						value={naamFilter}
						label="Naam"
						onChange={onChangeFilter}
						size={6}
						disabled={validRelatieTypeSelected}
						hasFocus={naamFilterHasFocus && !validRelatieTypeSelected} />
				</Row>
				<Row>
					<Button style={{ marginLeft: '.83333%', paddingLeft: '1.1em' }} onClick={onSearch} text="Zoek" className="o-col-1" disabled={validRelatieTypeSelected} />
				</Row>
				&nbsp;
                {searchResultRows && searchResultRows.length > 0 ?
					<Table
						headerSizes={[3, 43, 18, 18, 18]}
						headers={["", "Naam (Afkorting)", "Type", "Sporttak"]}>
						{searchResultRows}
					</Table> : null}
			</Fieldset>
		</Form>
	);
};

LinkAddForm.propTypes = {
	onCancel: PropTypes.func,
	onContinue: PropTypes.func,
	orgTypes: PropTypes.array,
	sporttakken: PropTypes.array,
	typeFilter: PropTypes.object,
	idFilter: PropTypes.object,
	naamFilter: PropTypes.object,
	relatieType: PropTypes.object,
	sporttakFilter: PropTypes.object,
	onChangeFilter: PropTypes.func,
	onSearch: PropTypes.func,
	searchModels: PropTypes.array,
	onChangeToAdd: PropTypes.func,
	models: PropTypes.array,
	sportVlaanderenRoot: PropTypes.string,
	naamFilterHasFocus: PropTypes.bool,
	userType: PropTypes.string
};

export default LinkAddForm;
